import { connect } from 'react-redux';
import { mapStateToProps } from './connect/single-view-design-upload.selector';
import { makeDispatcher } from './connect/single-view-design-upload.dispatcher';
import { SingleViewDesignUploadComponent } from './single-view-design-upload';
export const SingleViewDesignUpload = connect(mapStateToProps, makeDispatcher)(SingleViewDesignUploadComponent);